import React, {memo, RefObject, useCallback, useEffect} from "react";
import styles from "./Caption.module.css";
import {ParentComponentProps} from "../../../../../common/ParentComponentProps";
import {Text14} from "../../../../../common/components/typography/Typography";
import clsx from "clsx";
import {stringifyVideoTimeWithColons} from "../../../../../common/video/util/videoTimeStrings";
import EditCaption from "../../../../../pages/vod/Common/EditCaption";
import {isAdmin, isPresenter} from "../../../../../user/User";
import {useSelector} from "react-redux";
import {AppState} from "../../../../../root/RootReducer";
import PuiTypography from "../../../../../components/elements/PuiTypography";
import useResponsive from "../../../../../common/useResponsive";

interface CaptionProps extends ParentComponentProps {
    isCurrentCaption: boolean;
    videoRef: RefObject<HTMLVideoElement>;
    startTimeMillis: number;
    id: number;
    text: string;
    captionElement: null | HTMLElement;
}

function Caption({children, isCurrentCaption, startTimeMillis, videoRef, id, text, captionElement}: CaptionProps) {
    const { isDesktop, isMobile } = useResponsive();
    // ユーザーロール取得用
    const {user} = useSelector((state: AppState) => ({
        user: state.user.userInfo
    }));

    const { userInfo, video } =
    useSelector((state: AppState) => {
      return {
        userInfo: state.user.userInfo,
        isRerunSTT: state.exVideo.caption.isRerunSTT,
        videoOption: state.exVideo.videoOption,
        video: state.video.video,
        isResetVideo: state.video.isResetVideo,
      };
    });
    const classes = clsx(styles.caption, {
        [styles.currentCaption]: isCurrentCaption
    });

    const handleClick = useCallback(() => {
        if (videoRef && videoRef.current) {
            videoRef.current.currentTime = startTimeMillis / 1000;
       }
   }, [startTimeMillis, videoRef]);

    // スクロール位置更新
    useEffect(() => {
        if(isCurrentCaption === true && captionElement !== null){
            if(captionElement){
                const offsetTop = captionElement.offsetTop;
                const currentCaption = document.getElementById(String(id));
                if(currentCaption){
                    if (isMobile) {
                        captionElement.scrollLeft = currentCaption.offsetLeft - captionElement.offsetLeft;
                    } else {
                        const top = currentCaption.offsetTop;
                        captionElement.scrollTop = top - offsetTop;
                    }
               }
           }
       }
    // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [isCurrentCaption]);


    const isPre = video.presenterId == userInfo?.id && isPresenter(userInfo?.roles);
    return (
        <div className={classes} onClick={handleClick} id={String(id)}>
            <div className={styles.timestamp}>
                <PuiTypography size={isMobile ? 12 : 14} color="gray-61" >
                    {stringifyVideoTimeWithColons(startTimeMillis, true)}
                </PuiTypography>
                {
                    (isAdmin(userInfo?.roles) || isPre) && isDesktop &&
                        <div style={{marginLeft:"6px"}}>
                            <EditCaption captionId={id} beforeEditText={text}/>
                        </div>
               }
            </div>

            <div className={styles.body}>
                <Text14>{children}</Text14>
            </div>
        </div>
    );
}

export default memo(Caption);
